import jump from 'jump.js';

const smoothscroll = Array.from(document.querySelectorAll('.smoothscroll'));

smoothscroll.forEach((link) => {
  link.addEventListener('click', function (event) {
    event.preventDefault();

    const hash = this.hash;
    const anchor = document.getElementById(hash.substr(1));
    const offset = this.dataset.offset ? parseInt(this.dataset.offset, 10) : 0;

    jump(anchor, { offset, duration: 500 });
  });
});



// WEBPACK FOOTER //
// ./scripts/scrollto.js